import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { MenuItemGroup } from '@/models/metadata';
import { BuilderModeKind, CustomerProfile, MealType, Menu } from '@/models';
import { TopLevelMenuImageContent } from '@/models/adobe-target';
import { PreHideStyleID } from '@/services/adobe-target/adobe-target.service';

@Component({
  name: 'CmgMealBuilderHeader',
})
export default class CmgMealBuilderHeader extends Vue {
  @Prop({ required: false, type: String })
  price?: string;

  @Prop({ required: true, type: Object })
  group!: MenuItemGroup;

  @Prop({ required: false, type: Object })
  selectedQuantityGroup?: MenuItemGroup;

  @Prop({ required: false, type: Object })
  menu?: Menu;
  
  get displayName(): string {
    return this.group.type == 'quantity' && this.selectedQuantityGroup ? this.selectedQuantityGroup.description : this.group.displayName;
  } 

  get bannerImageUrl(): string {
    if (this.targetImageContent) {
      return this.targetImageContent.bannerImageUrl;
    }

    return this.group.type == 'quantity' && this.selectedQuantityGroup ? this.selectedQuantityGroup.bannerImageUrl : this.group.bannerImageUrl;
  }

  get targetImageContent(): TopLevelMenuImageContent | undefined {
    return this.$appStore.state.adobeTarget.topLevelMenuImages.find(t => t.topLevelMenuTitle == this.group.displayName);
  }

  get customerProfile(): CustomerProfile | null {
    return this.$appStore.state.customer.profile;
  }

  get headerText(): string {
    return this.$appStore.state.mealBuilder.builderMode?.mode == BuilderModeKind.ZeroVariant && !this.group.menuItemType ? 'CHOOSE YOUR' : 'BUILD YOUR';
  }

  get preconfiguredMealHeaderText(): string {
    return this.group.menuItemType != MealType.HighProtein ? 'PICK YOUR' : '';
  }

  get displayPrice(): boolean {
    return !!this.price;
  }

  @Watch('customerProfile', { immediate: true })
  async onCustomerProfileChanged(customerProfile: CustomerProfile | null) {
    if (!customerProfile) {
      return;
    }

    await this.$services.recentAndFavoriteOrders.refreshRecentOrders();
  }

  mounted() {    
    this.$services.adobeTarget.prehideContent(PreHideStyleID.mealBuilderHeaderImage, 5000);
  }
}
